module.exports = "/images/flag-gb.svg?60eba90b7342d885d63b9df835ab2457";